// User account dropdown — vanilla JS, no Stimulus

function closeUserMenu() {
  const panel = document.getElementById("user-menu-panel");
  const trigger = document.getElementById("user-menu-trigger");
  if (panel) panel.classList.remove("open");
  if (trigger) trigger.setAttribute("aria-expanded", "false");
}

function openUserMenu() {
  const panel = document.getElementById("user-menu-panel");
  const trigger = document.getElementById("user-menu-trigger");
  if (panel) panel.classList.add("open");
  if (trigger) trigger.setAttribute("aria-expanded", "true");
}

// Document-level handlers registered ONCE — look up elements dynamically
// so they stay correct after Turbo replaces the DOM.
document.addEventListener("click", function (e) {
  const panel = document.getElementById("user-menu-panel");
  const trigger = document.getElementById("user-menu-trigger");
  if (!panel || !panel.classList.contains("open")) return;
  if (!panel.contains(e.target) && e.target !== trigger) {
    closeUserMenu();
  }
});

document.addEventListener("keydown", function (e) {
  if (e.key === "Escape") closeUserMenu();
});

// Reset state before Turbo caches the page so snapshots never contain an open dropdown.
document.addEventListener("turbo:before-cache", closeUserMenu);

function initUserMenu() {
  const trigger = document.getElementById("user-menu-trigger");
  if (!trigger) return;

  // Guard against duplicate listeners when turbo:load fires more than once
  // for the same DOM element (e.g. cache preview + fresh page).
  if (trigger.dataset.menuInitialized) return;
  trigger.dataset.menuInitialized = "true";

  trigger.addEventListener("click", function (e) {
    e.stopPropagation();
    const panel = document.getElementById("user-menu-panel");
    if (panel && panel.classList.contains("open")) {
      closeUserMenu();
    } else {
      openUserMenu();
    }
  });
}

// turbo:load fires on the initial page load AND after every Turbo navigation,
// so DOMContentLoaded is not needed and would cause a double-init on first load.
document.addEventListener("turbo:load", initUserMenu);
